import { Flex, Spin } from 'antd'
import type { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  minHeight?: number | string
  style?: CSSProperties
}

/** Centered loading indicator for cards and sections (accessible status region). */
export const ContentSpinner = ({ minHeight = 160, style }: Props) => {
  const { t } = useTranslation()

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={t('ui.loading')}
    >
      <Flex align="center" justify="center" style={{ minHeight, ...style }}>
        <Spin size="large" description={t('ui.loading')} />
      </Flex>
    </div>
  )
}
